module.exports = __webpack_public_path__ + "static/arch-e2b1ff83c637a8b84dcc7768053e6c26.svg";